import React, { Component } from 'react';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import EventDetailsPage from './eventdetails';
import { EventDetail, EventDetailByUser, JoinEvent } from "../../models/events";
import AppUtils from '../../apputils';
import $ from 'jquery';
import ConfirmationModal from './confirmationModal';
var gapi = window.gapi;
var clientID = '833238440283-s64g3p22cvd7vfb00jmpv47i2kap8bvf.apps.googleusercontent.com';
var apiKey = 'AIzaSyCBydqFkMfCwgYuDm4nspbttp_hZwj5WaU';
var discovery_docs = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];
var scopes = "https://www.googleapis.com/auth/calendar.events";

class eventDetails extends Component {
    constructor() {
        super()
        this.state = {
            eventId: '',
            event_details: false,
            joint_event: false,
            eventName: '',
            eventImage: '',
            eventStarDateTime: '',
            eventDate: '',
            eventTime: '',
            eventMode: '',
            eventLeftSeats: '',
            eventDuration: '',
            eventOrganizerPic: '',
            eventOrganizerName: '',
            eventOrganizerId:'',
            eventLanguage: '',
            eventDesc: '',
            isModalOpen: false,
            eventJoinStatus: false,
            EventDetailsData: {}
        }
        this.dataObj = {};

    }

    componentDidMount = () => {

       // alert(this.props.componentprops.match.params.id)
        let event_id =  this.props.componentprops.match.params.id

    //    event_id = event_id.slice(event_id.lastIndexOf('-')+1)

    //    alert(event_id)

        if (this.props.componentprops.currentAction !== undefined && this.props.componentprops.currentAction.action === 'Detail') {
            // alert('dddd' + this.props.componentprops.currentAction.id)
            this.setState({
                eventId: this.props.componentprops.currentAction.id,
                event_details: true
            })
        }
        else {
            this.setState({
                eventId: event_id,
                event_details: true,

            })
            //console.log(this.props.componentprops.match.params.id)
        }
    }

    LeftTime = (leftTime) => {
        //alert(left);
        leftTime = leftTime.replace(/  /g, 'T');
        var curr_time = new Date();
        var startTime = new Date(leftTime);
        var diff = startTime.getTime() - curr_time.getTime()

        // let diff_in_day = diff / (1000 * 60 * 60 * 24);
        // let left_day_hours;
     
         //   alert(diff)
            return diff;
        
    }

  HandleClose = ()=>{
    this.props.componentprops.currentAction.close();
  }

    HandleRouting = (route) => {
       // alert(JSON.stringify(this.props.componentprops));
    
        AppUtils.HandlePageClick(this.props.componentprops, route)
        this.HandleClose();
    }

    HandleGetEventDetailsSuccessResponse = (res) => {
        //  alert('id' + this.state.eventId)
        //  alert('jjjj')
        //  alert(JSON.stringify(res))
        if (res !== false) {
            let eventJoinStatus = false
            let data = '';
            if (res.data.eventdetails === undefined) {
                data = res.data[0];

                if (res.data[1].eventjoindetails.rows.length > 0) {
                    eventJoinStatus = true
                }
            }
            else {
                data = res.data
            }

            var date = new Date((data.eventdetails.rows[0].event_start_time).replace(/  /g, 'T')).toDateString();
            // alert(date.slice(3))
            var datefinal = date.slice(0, 3) + "," + date.slice(3);
            // alert(datefinal)
            //alert(date);
            //  var time = new Date(data.eventdetails.rows[0].event_start_time).toTimeString();

            var hr = new Date((data.eventdetails.rows[0].event_start_time).replace(/  /g, 'T')).getHours();
            var min = new Date((data.eventdetails.rows[0].event_start_time).replace(/  /g, 'T')).getMinutes();
            let final;

            if (hr > 12) {
                hr = hr - 12
                if (min < 10) {
                    min = '0' + min;
                }
                final = hr + ':' + min + ' ' + 'PM';
            }
            else if (hr === 12) {

                if (min < 10) {
                    min = '0' + min;
                }

                final = hr + ':' + min + ' ' + 'PM';
            }

            else {

                if (min < 10) {
                    min = '0' + min;
                }

                final = hr + ':' + min + ' ' + 'AM';
            }

            var eventimg = data.eventdetails.rows[0].event_image.replace(',', '');

            var seatsLeft = data.eventdetails.rows[0].event_total_seats - (data.eventdetails.rows[0].event_filled_seats + data.eventdetails.rows[0].event_already_filled_seats)
            // alert(JSON.stringify(data.eventdetails))

            this.setState({
                eventId: data.eventdetails.rows[0]._id,
                EventDetailsData: data.eventdetails.rows[0],
                eventName: data.eventdetails.rows[0].event_name,
                eventStarDateTime: data.eventdetails.rows[0].event_start_time,
                eventImage: eventimg,
                eventDate: datefinal,
                eventDuration: data.eventdetails.rows[0].event_duration,
                eventTime: final,
                eventDesc: data.eventdetails.rows[0].event_desc,
                eventMode: data.eventdetails.rows[0].event_mode,
                eventLeftSeats: seatsLeft,
                eventLanguage: data.eventdetails.rows[0].event_language,
                eventOrganizerName: data.eventdetails.rows[0].organizer_details[0].organizer_name,
                eventOrganizerPic: data.eventdetails.rows[0].organizer_details[0].organizer_image,
                eventOrganizerId:data.eventdetails.rows[0].organizer_details[0]._id,
                event_details: false,
                eventJoinStatus: eventJoinStatus
            })


        }

        else {
            this.setState({
                event_details: false
            })
        }
    }

    AddEventGoogleCalendar = () => {

        //   alert(JSON.stringify(this.data))

        gapi.load('client:auth2', () => {
            console.log('loaded client');
            gapi.client.init({
                apiKey: apiKey,
                clientId: clientID,
                discoveryDocs: discovery_docs,
                scope: scopes
            })
            gapi.client.load('calendar', 'v3', () => {
                console.log('bam!');
            })
            gapi.auth2.getAuthInstance().signIn()
                .then(() => {
                    var start_time = new Date(this.state.eventStarDateTime)
                    var end_time = new Date(this.state.eventStarDateTime)
                    var endtime = end_time.getTime();
                    var duration = this.state.eventDuration * 60000;
                    var final_end_time = new Date(endtime + duration);
                    final_end_time.toISOString();
                    //  alert(final_end_time);
                    start_time.toISOString();
                    //  alert(start_time);
                    // var end_time = new Date(this.data.txtEventStartTime.getTime() + this.data.txtEventDuration*60000);
                    //var end_time = new Date(this.state.txtEventEndTime)
                    //  alert(end_time)
                    // end_time.toISOString();
                    //  alert(' end time' +end_time)
                    var event = {
                        'summary': this.state.eventName,
                        // 'location': this.data.ddlEventMode,
                        'description': this.state.eventDesc,
                        'start': {
                            'dateTime': start_time,
                            'timeZone': 'GMT+05:30'
                        },
                        'end': {
                            'dateTime': final_end_time,
                            'timeZone': 'GMT+05:30'
                        },
                        // 'recurrence': [
                        //   'RRULE:FREQ=DAILY;COUNT=2'
                        // ],
                        // 'attendees': [
                        //     { 'email': 'ausafsjc97@gmail.com' },
                        //     { 'email': 'sbrin@example.com' }
                        // ],
                        'reminders': {
                            'useDefault': false,
                            'overrides': [
                                { 'method': 'email', 'minutes': 24 * 60 },
                                { 'method': 'popup', 'minutes': 10 }
                            ]
                        }
                    };
                    var request = gapi.client.calendar.events.insert({
                        'calendarId': 'primary',
                        'resource': event
                    });

                    request.execute(event => {
                        window.open(event.htmlLink);
                    });
                })
        })


    }

    HideConfirmationModal = () => {
        this.setState({ isModalOpen: false }, () =>
            //console.log("Hide Contact Modal")
            AppUtils.HandlePageClick(this.props.componentprops, "upcoming-sessions")
        );
    };

    JoinEvent = () => {

        if (localStorage.getItem('current_user_name') !== null && localStorage.getItem('current_user_login_token') !== null && localStorage.getItem('current_user_profile') !== null) {

            this.dataObj = {
                user_id: localStorage.getItem('current_user_id'),
                event_id: this.state.eventId
            }

            this.setState({
                joint_event: true
            })
        }
        else {
            AppUtils.HandlePageClick(this.props.componentprops, "login")
        }


    }

    HandleJoinEventSuccessResponse = (res) => {

        if (res !== false) {

            this.AddEventGoogleCalendar();

            this.setState({
                isModalOpen: true,
                joint_event: false
            })

            console.log(JSON.stringify(res))

            // AppUtils.HandlePageClick(this.props.componentprops, 'event-confirmation');
        }

        else {
            this.setState({
                joint_event: false
            })
            document.getElementById('spnWarningMessageTitle').innerText = "Server Response - ";
            document.getElementById('spnWarningMessage').innerText = "Already Registerd Member";
            let that = this;
            $('#crmWarningAlert').slideDown().slideUp(3000, function () {
                AppUtils.HandlePageClick(that.props.componentprops, 'booked-sessions');
            })
        }


        this.setState({
            joint_event: false
        })
    }

    render() {
        return (
            <div style={{ marginTop: '90px' }}>
                <EventDetailsPage {...this.props} EventDetailsData={this.state.EventDetailsData} mystate={this.state}
                HandleRouting={this.HandleRouting}
                    JoinEvent={this.JoinEvent}
                    LeftTime={this.LeftTime}
                />
                <ConfirmationModal {...this.props} isModalOpen={this.state.isModalOpen} HandleRouting={this.HandleRouting}
                    HideConfirmationModal={this.HideConfirmationModal}
                />
                {
                    localStorage.getItem('current_user_id') !== undefined && localStorage.getItem('current_user_id') !== null && localStorage.getItem('current_user_id') !== '' ?
                        ((this.state.event_details === true) ? EventDetailByUser(this.props.PnkStore, this.state.eventId, localStorage.getItem('current_user_id'), this.HandleGetEventDetailsSuccessResponse) : "")
                        :
                        ((this.state.event_details === true) ? EventDetail(this.props.PnkStore, this.state.eventId, this.HandleGetEventDetailsSuccessResponse) : "")
                }


                {((this.state.joint_event === true) ? JoinEvent(this.props.PnkStore, this.dataObj, this.HandleJoinEventSuccessResponse) : "")}
            </div>
        )
    }
}

export const EventDetails = PnkConnect(eventDetails, '');